export default __webpack_public_path__ + "static/media/T01.86070cee.png";